(function(app) {

    app.provider("permissionApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.getDelegatePermissions = function (userDelegateId) {
                        return portalApiGateway.getArray("/Permissions/Delegates/" + userDelegateId);
                    };

                    service.getPolicyStatements = function getPolicyStatements() {
                        return portalApiGateway.getArray("/Permissions/PolicyStatements");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app);